import { Action } from "@ngrx/store";

export enum TransportActionTypes {
  GET_TRANSPORT_PRICE_LIST = "[Transport] Get Transport Price List",
  GET_TRANSPORT_PRICE_LIST_SUCCESS = "[Transport] Get Transport Price List Success",
  GET_TRANSPORT_PRICE_LIST_FAILURE = "[Transport] Get Transport Price List Error",

  GET_TRANSPORT_PRICE = "[Transport] Get Transport Price",
  GET_TRANSPORT_PRICE_SUCCESS = "[Transport] Get Transport Price Success",
  GET_TRANSPORT_PRICE_FAILURE = "[Transport] Get Transport Price Error",
  
  GET_DISCOUNTED_TRANSPORT_PRICE = "[Transport] Get Discounted Transport Price",
  GET_DISCOUNTED_TRANSPORT_PRICE_SUCCESS = "[Transport] Get Discounted Transport Price Success",
  GET_DISCOUNTED_TRANSPORT_PRICE_FAILURE = "[Transport] Get Discounted Transport Price Error",
  
  CREATE_DISCOUNTED_TRANSPORT_PRICE = "[Transport] Create Discounted Transport Price",
  CREATE_DISCOUNTED_TRANSPORT_PRICE_SUCCESS = "[Transport] Create Discounted Transport Price Success",
  CREATE_DISCOUNTED_TRANSPORT_PRICE_FAILURE = "[Transport] Create Discounted Transport Price Error",
  
  UPDATE_DISCOUNTED_TRANSPORT_PRICE = "[Transport] Update Discounted Transport Price",
  UPDATE_DISCOUNTED_TRANSPORT_PRICE_SUCCESS = "[Transport] Update Discounted Transport Price Success",
  UPDATE_DISCOUNTED_TRANSPORT_PRICE_FAILURE = "[Transport] Update Discounted Transport Price Error",

  CLEAR_TRANSPORT_PRICE_LIST = "[Transport] Clear Transport Price List",

  GET_TRANSPORT_OPTIONS = "[Transport] Get Transport Options",
  GET_TRANSPORT_OPTIONS_SUCCESS = "[Transport] Get Transport Options Success",
  GET_TRANSPORT_OPTIONS_FAILURE = "[Transport] Get Transport Options Error",

  GET_TRANSPORT_LOADS = "[Transport] Get Transport Loads",
  GET_TRANSPORT_LOADS_SUCCESS = "[Transport] Get Transport Loads Success",
  GET_TRANSPORT_LOADS_FAILURE = "[Transport] Get Transport Loads Error",
  
  // GET_TRANSPORT_LOADS_PURCHASE = "[Transport] Get Transport Loads Purchase",
  // GET_TRANSPORT_LOADS_PURCHASE_SUCCESS = "[Transport] Get Transport Loads Purchase Success",
  // GET_TRANSPORT_LOADS_PURCHASE_FAILURE = "[Transport] Get Transport Loads Purchase Error",

  GET_TRANSPORT_AREAS = "[Transport] Get Transport Areas",
  GET_TRANSPORT_AREAS_SUCCESS = "[Transport] Get Transport Areas Success",
  GET_TRANSPORT_AREAS_FAILURE = "[Transport] Get Transport Areas Error",

  GET_TRANSPORT_DISTRICTS = "[Transport] Get Transport Districts",
  GET_TRANSPORT_DISTRICTS_SUCCESS = "[Transport] Get Transport Districts Success",
  GET_TRANSPORT_DISTRICTS_FAILURE = "[Transport] Get Transport Districts Error",

  CLEAR_TRANSPORT_AREAS = "[Transport] Clear Transport Areas",
  CLEAR_TRANSPORT_DISTRICTS = "[Transport] Clear Transport Districts",
}

export class GetTransportPriceList implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_PRICE_LIST;
  constructor(public payload: any) { }
}

export class GetTransportPriceListSuccess implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_PRICE_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetTransportPriceListFailure implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_PRICE_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class GetTransportPrice implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_PRICE;
  constructor(public payload: any) { }
}

export class GetTransportPriceSuccess implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_PRICE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetTransportPriceFailure implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_PRICE_FAILURE;
  constructor(public payload: any) { }
}

export class GetDiscountedTransportPrice implements Action {
  readonly type = TransportActionTypes.GET_DISCOUNTED_TRANSPORT_PRICE;
  constructor(public payload: any) { }
}

export class GetDiscountedTransportPriceSuccess implements Action {
  readonly type = TransportActionTypes.GET_DISCOUNTED_TRANSPORT_PRICE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetDiscountedTransportPriceFailure implements Action {
  readonly type = TransportActionTypes.GET_DISCOUNTED_TRANSPORT_PRICE_FAILURE;
  constructor(public payload: any) { }
}

export class CreateDiscountedTransportPrice implements Action {
  readonly type = TransportActionTypes.CREATE_DISCOUNTED_TRANSPORT_PRICE;
  constructor(public payload: any) { }
}

export class CreateDiscountedTransportPriceSuccess implements Action {
  readonly type = TransportActionTypes.CREATE_DISCOUNTED_TRANSPORT_PRICE_SUCCESS;
  constructor(public payload: any) { }
}

export class CreateDiscountedTransportPriceFailure implements Action {
  readonly type = TransportActionTypes.CREATE_DISCOUNTED_TRANSPORT_PRICE_FAILURE;
  constructor(public payload: any) { }
}

export class UpdateDiscountedTransportPrice implements Action {
  readonly type = TransportActionTypes.UPDATE_DISCOUNTED_TRANSPORT_PRICE;
  constructor(public payload: any, public id: any) { }
}

export class UpdateDiscountedTransportPriceSuccess implements Action {
  readonly type = TransportActionTypes.UPDATE_DISCOUNTED_TRANSPORT_PRICE_SUCCESS;
  constructor(public payload: any) { }
}

export class UpdateDiscountedTransportPriceFailure implements Action {
  readonly type = TransportActionTypes.UPDATE_DISCOUNTED_TRANSPORT_PRICE_FAILURE;
  constructor(public payload: any) { }
}

export class ClearTransportPriceList implements Action {
  readonly type = TransportActionTypes.CLEAR_TRANSPORT_PRICE_LIST;
  constructor() { }
}

export class GetTransportOptions implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_OPTIONS;
  constructor() { }
}

export class GetTransportOptionsSuccess implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_OPTIONS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetTransportOptionsFailure implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_OPTIONS_FAILURE;
  constructor(public payload: any) { }
}

// export class GetTransportLoadsPurchase implements Action {
//   readonly type = TransportActionTypes.GET_TRANSPORT_LOADS_PURCHASE;
//   constructor() { }
// }

// export class GetTransportLoadsPurchaseSuccess implements Action {
//   readonly type = TransportActionTypes.GET_TRANSPORT_LOADS_PURCHASE_SUCCESS;
//   constructor(public payload: any) { }
// }

// export class GetTransportLoadsPurchaseFailure implements Action {
//   readonly type = TransportActionTypes.GET_TRANSPORT_LOADS_PURCHASE_FAILURE;
//   constructor(public payload: any) { }
// }

export class GetTransportLoads implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_LOADS;
  constructor() { }
}

export class GetTransportLoadsSuccess implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_LOADS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetTransportLoadsFailure implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_LOADS_FAILURE;
  constructor(public payload: any) { }
}

export class GetTransportAreas implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_AREAS;
  constructor(public payload: any) { }
}

export class GetTransportAreasSuccess implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_AREAS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetTransportAreasFailure implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_AREAS_FAILURE;
  constructor(public payload: any) { }
}

export class GetTransportDistricts implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_DISTRICTS;
  constructor(public payload: any) { }
}

export class GetTransportDistrictsSuccess implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_DISTRICTS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetTransportDistrictsFailure implements Action {
  readonly type = TransportActionTypes.GET_TRANSPORT_DISTRICTS_FAILURE;
  constructor(public payload: any) { }
}

export class ClearTransportAreas implements Action {
  readonly type = TransportActionTypes.CLEAR_TRANSPORT_AREAS;
  constructor() { }
}

export class ClearTransportDistricts implements Action {
  readonly type = TransportActionTypes.CLEAR_TRANSPORT_DISTRICTS;
  constructor() { }
}

export type TransportActions =
  | GetTransportPriceList
  | GetTransportPriceListSuccess
  | GetTransportPriceListFailure
  | GetTransportPrice
  | GetTransportPriceSuccess
  | GetTransportPriceFailure
  | GetDiscountedTransportPrice
  | GetDiscountedTransportPriceSuccess
  | GetDiscountedTransportPriceFailure
  | CreateDiscountedTransportPrice
  | CreateDiscountedTransportPriceSuccess
  | CreateDiscountedTransportPriceFailure
  | UpdateDiscountedTransportPrice
  | UpdateDiscountedTransportPriceSuccess
  | UpdateDiscountedTransportPriceFailure
  | ClearTransportPriceList
  | GetTransportOptions
  | GetTransportOptionsSuccess
  | GetTransportOptionsFailure
  | GetTransportLoads
  | GetTransportLoadsSuccess
  | GetTransportLoadsFailure
  // | GetTransportLoadsPurchase
  // | GetTransportLoadsPurchaseSuccess
  // | GetTransportLoadsPurchaseFailure
  | GetTransportAreas
  | GetTransportAreasSuccess
  | GetTransportAreasFailure
  | GetTransportDistricts
  | GetTransportDistrictsSuccess
  | GetTransportDistrictsFailure
  | ClearTransportAreas
  | ClearTransportDistricts;